import { formOptions } from '@tanstack/react-form';

export const sendSurveyFormOptions = formOptions({
	defaultValues: {
		survey_version: '',
		send_date: '',
		send_time: '',
	},
});
